import React, {useEffect, useState} from "react";
import UserManagerPage from "./UserManagerPage";
import {IonButton, IonCheckbox, IonInput, IonItem, IonLabel, IonLoading, useIonAlert} from "@ionic/react";
import { useMutation } from "@apollo/client";
import {useHistory} from "react-router-dom";
import {USER_MANAGER_CREATE_RULE} from "../../schemas/userManager";

const UserManagerCreateRule: React.FC<any> = () => {

    const history = useHistory();
    const [alert, dismissAlert] = useIonAlert();
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [createRuleMutation] = useMutation(USER_MANAGER_CREATE_RULE);


    const [name, setName] = useState<string | null | undefined>(undefined);
    const [details, setDetails] = useState<string | null |  undefined>(undefined);


    const createRule = async () => {
        // validate name and details
        setIsLoading(true);
        let validationErrors: string[] = [];
        if (!name || name.length < 2) {
            validationErrors.push("Please enter a name");
        }
        if (!details || details.length < 2) {
            validationErrors.push("Please enter details");
        }
        if (validationErrors.length > 0) {
            setIsLoading(false);
            await alert("Errors: <ul><li>" + validationErrors.join("</li><li>") + '</li></ul>');
            return;
        }

        // submit
        const createResult = await createRuleMutation({variables: {data: {name, details}}});
        setIsLoading(false);
        if (createResult.data.userManagerCreateRule.success) {
            await alert("Successfully created rule");
            setName(undefined);
            setDetails(undefined);
        } else {
            await alert("Error: " + createResult.data.userManagerCreateRule.error);
        }
    };

    return (
        <UserManagerPage page={'create-rule'}>
            <IonLoading isOpen={isLoading}/>

            <div className="userManagerContent">
                <div style={{backgroundColor: '#ffffff', padding: '10px', margin: '0px'}}>

                    <h1 style={{backgroundColor: '#ffffff', padding: '0px', margin: '0px'}}>Create Rule</h1>

                    <p>Enter the rule name and the some details about the rule.</p>

                    <IonInput label="Name" labelPlacement="floating" fill="solid" id="txtName" onIonChange={(e) => setName(e.detail.value)} value={name}></IonInput>

                    <IonInput label="Details" labelPlacement="floating" fill="solid" id="txtDetails"  onIonChange={(e) => setDetails(e.detail.value)} value={details}></IonInput>

                    <div style={{clear: "both"}}></div>

                    <p style={{textAlign: 'right'}}>
                        <IonButton fill="outline" onClick={() => history.goBack()}>Go Back</IonButton>
                        <IonButton onClick={() => createRule()}>Create Rule</IonButton>
                    </p>
                </div>
            </div>
        </UserManagerPage>
    );
};


export default UserManagerCreateRule;